import { IconOrganisationSitesFilled } from '@gmg/gmg-react-components';
import { FC, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetOrganizationSites } from '../../graphql/useGetOrganizationSites';
import OrganizationContainer from '../OrganizationContainer';
import SitesList from './SitesList';
import AppContext from '../../AppContext';


const SitesManagement: FC = () => {
    const { t } = useTranslation();
    const { orgId } = useParams();
    const context = useContext(AppContext);
    const { data: sites = [], isLoading, error } = useGetOrganizationSites(orgId!);

    useEffect(() => {
        if (!error) {
            return;
        }
        context.onError(error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);

    return (
        <OrganizationContainer
            onOrganizationLoad={() => { }}
            viewInfo={{
                icon: <IconOrganisationSitesFilled width={16} height={16} />,
                label: t('HeaderPageTitles.sites_management_title', 'Sites'),
            }}
        >
            <SitesList sites={sites} isLoading={isLoading} />
        </OrganizationContainer>
    );
};

export default SitesManagement;
